import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { CommunicationDirection } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'communication-direction',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './communication-direction.component.html',
})
export class CommunicationDirectionComponent {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);

  communicationDirection = CommunicationDirection;

  constructor() {}

  ngOnInit(): void {}
}
